import { Action } from '@ngrx/store';

export enum ProActionTypes {
  CalculateProNodes = '[Pro] Calculate Pro Nodes',
  CalculateProNodesSuccess = '[Pro] Calculate Pro Nodes Success',
  CheckProUpgrade = '[Pro] Check Pro Upgrade',
  ActivateProUpgrade = '[Pro] Activate Pro Upgrade',
  ActivateProUpgradeSuccess = '[Pro] Activate Pro Upgrade Success',
  ActivateProUpgradeFailure = '[Pro] Activate Pro Upgrade Failure',
  TransferProNodes = '[Pro] Transfer Pro Nodes',
  GetProNodesBank = '[Pro] Get Pro Nodes Bank',
  GetProNodesBankSuccess = '[Pro] Get Pro Nodes Bank Success',
  GetProNodesBankFailure = '[Pro] Get Pro Nodes Bank Failure',
  SendProUpgradeMail = '[Pro] Send Pro Upgrade Mail',
  SendProPaymentDocumentMail = '[Pro] Send Pro Payment Document Mail',
  AddProPaymentPay = '[Pro] Add Pro Payment Pay',
  ActivatePayPalAgreement = '[Pro] Activate PayPal Agreement'
}

export class CalculateProNodes implements Action {
  readonly type = ProActionTypes.CalculateProNodes;

  constructor(public payload: any = null) {}
}

export class CalculateProNodesSuccess implements Action {
  readonly type = ProActionTypes.CalculateProNodesSuccess;

  constructor(public payload: any = null) {}
}

export class CheckProUpgrade implements Action {
  readonly type = ProActionTypes.CheckProUpgrade;

  constructor(public payload: any = null) {}
}

export class ActivateProUpgrade implements Action {
  readonly type = ProActionTypes.ActivateProUpgrade;

  constructor(public payload: any = null) {}
}

export class ActivateProUpgradeSuccess implements Action {
  readonly type = ProActionTypes.ActivateProUpgradeSuccess;

  constructor(public payload: { result: boolean, message: string }) {}
}

export class ActivateProUpgradeFailure implements Action {
  readonly type = ProActionTypes.ActivateProUpgradeFailure;

  constructor(public payload: { error: string }) {}
}

export class AddProPaymentPay implements Action {
  readonly type = ProActionTypes.AddProPaymentPay;

  constructor(public payload: any = null) {}
}

export class TransferProNodes implements Action {
  readonly type = ProActionTypes.TransferProNodes;

  constructor(public payload: any = null) {}
}

export class GetProNodesBank implements Action {
  readonly type = ProActionTypes.GetProNodesBank;

  constructor(public payload: any = null) {}
}

export class GetProNodesBankSuccess implements Action {
  readonly type = ProActionTypes.GetProNodesBankSuccess;

  constructor(public payload: any = null) {}
}

export class GetProNodesBankFailure implements Action {
  readonly type = ProActionTypes.GetProNodesBankFailure;
  constructor(public payload: any = null) {}
}

export class SendProUpgradeMail implements Action {
  readonly type = ProActionTypes.SendProUpgradeMail;

  constructor(public payload: { RegionId: number }) {}
}

export class SendProPaymentDocumentMail implements Action {
  readonly type = ProActionTypes.SendProPaymentDocumentMail;

  constructor(public payload: any = null) {}
}

export class ActivatePayPalAgreement implements Action {
  readonly type = ProActionTypes.ActivatePayPalAgreement;

  constructor(public payload: any = null) {}
}

export type ProActions =
  | CalculateProNodes
  | CalculateProNodesSuccess
  | CheckProUpgrade
  | ActivateProUpgrade
  | ActivateProUpgradeSuccess
  | ActivateProUpgradeFailure
  | TransferProNodes
  | GetProNodesBank
  | GetProNodesBankSuccess
  | GetProNodesBankFailure
  | SendProUpgradeMail
  | SendProPaymentDocumentMail
  | AddProPaymentPay
  | ActivatePayPalAgreement;
